import { render } from "./settings.vue?vue&type=template&id=e6d344f2&scoped=true"
import script from "./settings.vue?vue&type=script&lang=ts"
export * from "./settings.vue?vue&type=script&lang=ts"

import "./settings.vue?vue&type=style&index=0&id=e6d344f2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e6d344f2"

export default script